/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isClaraEnabled: true,
    response: false,
    status: "clara",
    isClaraOpen: false,
    claraEnv: "",
    waiting: false
};

const claraSlice = createSlice({
    name: "clara",
    initialState: initialState,
    reducers: {
        addPayload: (state, action) => {
            state.value.push(action.payload)
        },
        setClaraResponse: (state, action) => {
            state.response = action.payload;
        },
        setClaraEnable: (state, action) => {
            state.isClaraEnabled = action.payload;
        },
        setClaraEnv: (state, action) => {
            state.claraEnv = action.payload;
        },
        toggleClara: (state) => {
            state.isClaraOpen = !state.isClaraOpen
        },
        setClaraStatus: (state, action) => {
            state.status = action.payload === "success" ? 
                "claraHappy" : action.payload === "error" ? "claraSad"
                : "clara"
        },
        setClaraWaiting: (state, action) => {
            state.waiting = action.payload
        }
    }
});

export const {
    setChecked,
    addPayload,
    setClaraResponse,
    setClaraEnable,
    toggleClara,
    setClaraEnv,
    setClaraStatus,
    setClaraWaiting
} = claraSlice.actions;

export default claraSlice;
